import {
  NL_SEARCH_INTENTS,
  NL_SEARCH_SCHEMA_VERSION,
  NL_SEARCH_SHARED_SCHEMA_VERSION,
  NL_SEARCH_CAD_SCHEMA_VERSION,
} from './nlSearchConstants';

/**
 * Casos del stub de Lambda (`FRONTEND_PARSE_SEARCH_QUERY.md` §5).
 * El mock del front los devuelve tal cual si `REACT_APP_NL_SEARCH_MOCK=true`.
 *
 * `flood_risk_pct` usa la key del panel (`"3"` = crítica), no el % crudo (`"100"`).
 */
const withMeta = (data) => ({
  schema_version: NL_SEARCH_SCHEMA_VERSION,
  confidence: 1,
  ...data,
});

export const NL_SEARCH_MOCK_CASES = [
  {
    query: 'lotes baldíos en la ciudad de cordoba capital que tengan entre 200 y 500 m2',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.hybrid,
      filters: { state: ['BALDIO'], surface: ['200-500'] },
      location: {
        kind: 'municipality',
        label: 'Córdoba Capital',
        query: 'Córdoba Capital, Córdoba, Argentina',
      },
      unresolved: [],
    }),
  },
  {
    query: 'Av. Vélez Sarsfield 1200, Córdoba',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.place,
      filters: {},
      location: {
        kind: 'address',
        label: 'Av. Vélez Sarsfield 1200, Córdoba',
        query: 'Av. Vélez Sarsfield 1200, Córdoba Capital, Córdoba, Argentina',
      },
      unresolved: [],
    }),
  },
  {
    query: 'Nueva Córdoba',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.place,
      filters: {},
      location: {
        kind: 'neighborhood',
        label: 'Nueva Córdoba',
        query: 'Nueva Córdoba, Córdoba, Argentina',
      },
      unresolved: [],
    }),
  },
  {
    query: 'lotes rurales de más de 5000 m2',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { type: ['RURAL'], surface: ['5k_10k', '1_5ha', '5_10ha', '10_20ha', '20_50ha', '50_100ha', 'gte100ha'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'terrenos en esquina con potencial de más de 1500 m2',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        street_position: ['corner'],
        buildable: [3, 4],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'parcelas urbanas sin cloaca en barrio cerrado',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        type: ['URBANO'],
        sewer_deficit_pct: 1,
        neighborhood_type: ['barrio_cerrado'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'lotes en inundación crítica en la provincia de Córdoba',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        flood_risk_pct: ['3'],
        province_name: ['Córdoba'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'lotes de menos de 200 m2',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { surface: ['lt200'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'baldíos entre 180 y 520 m2 en Córdoba capital',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.hybrid,
      filters: { state: ['BALDIO'], surface: ['200-500', '500-1000'] },
      location: {
        kind: 'municipality',
        label: 'Córdoba Capital',
        query: 'Córdoba Capital, Córdoba, Argentina',
      },
      unresolved: [
        'superficie exacta 180–520 m² (se usaron bandas 200–500 y 500–1.000)',
      ],
    }),
  },
  {
    query: 'departamentos en alquiler cerca del río Suquía, baratos',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.place,
      filters: {},
      location: {
        kind: 'locality',
        label: 'Río Suquía',
        query: 'Río Suquía, Córdoba, Argentina',
      },
      unresolved: [
        'departamentos (UF / publicación)',
        'alquiler (publicación)',
        'cerca de (no hay filtro de proximidad)',
        'baratos',
      ],
    }),
  },
  {
    query: 'lotes baldíos sin construcción en Córdoba capital',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.hybrid,
      filters: { state: ['BALDIO'] },
      location: {
        kind: 'municipality',
        label: 'Córdoba Capital',
        query: 'Córdoba Capital, Córdoba, Argentina',
      },
      unresolved: [],
    }),
  },
  {
    query: 'lotes de 500 a 1000 m2 en San Luis',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.hybrid,
      filters: {
        surface: ['500-1000'],
        province_name: ['San Luis'],
      },
      location: {
        kind: 'province',
        label: 'San Luis',
        query: 'San Luis, Argentina',
      },
      unresolved: [],
    }),
  },
  {
    query: 'lotes en country los quebrachos en san luis',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.hybrid,
      filters: {
        neighborhood_name: ['Los Quebrachos Country Golf'],
      },
      location: {
        kind: 'neighborhood',
        label: 'Los Quebrachos Country Golf',
        query: 'Los Quebrachos Country Golf, San Luis, Argentina',
        bbox: [-66.41, -33.32, -66.38, -33.29],
      },
      unresolved: [
        'barrio: se usó «Los Quebrachos Country Golf» (nombre del tile)',
      ],
    }),
  },
  {
    query: 'lotes en centro san luis',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        neighborhood_name: ['Centro'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'campos de 10 ha',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { surface: ['10_20ha'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'campos de 20 ha en mendoza',
    data: withMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        surface: ['20_50ha'],
        province_name: ['Mendoza'],
      },
      location: null,
      unresolved: [],
    }),
  },
];

const withSharedMeta = (data) => ({
  schema_version: NL_SEARCH_SHARED_SCHEMA_VERSION,
  confidence: 1,
  ...data,
});

/**
 * Stubs `context: shared-list` (mismas frases que Lambda).
 * Precio/moneda: venta → USD, alquiler → ARS. “Barato” se resuelve en el mock
 * del servicio con el primer corte de `listing_price_bands`.
 */
export const NL_SEARCH_SHARED_MOCK_CASES = [
  {
    query: 'en venta',
    data: withSharedMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        listing_operation: ['venta'],
        listing_currency: ['USD'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'depto de 80 m2',
    data: withSharedMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        building_type: ['departamento'],
        total_surface: ['70-120'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: '2 dormitorios',
    data: withSharedMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { bedrooms: ['2'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'baldíos en alquiler',
    data: withSharedMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        state: ['BALDIO'],
        listing_operation: ['alquiler'],
        listing_currency: ['ARS'],
      },
      location: null,
      unresolved: [],
    }),
  },
];

const withCadMeta = (data) => ({
  schema_version: NL_SEARCH_CAD_SCHEMA_VERSION,
  confidence: 1,
  ...data,
});

/** Stubs `context: cad-list` (`/#/lista/:id`). Sin Nominatim. */
export const NL_SEARCH_CAD_MOCK_CASES = [
  {
    query: 'en venta',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { stock_status: ['available', 'offer'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'lotes en venta de 200 a 500 m2',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        stock_status: ['available', 'offer'],
        surface: ['200-500'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'lotes de 200 a 500 m2',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { surface: ['200-500'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'disponibles',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { stock_status: ['available'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'en oferta',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: { stock_status: ['offer'] },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'menos de 80 mil dolares',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.filter,
      filters: {
        cad_price: { max: 80000 },
        currency: ['USD'],
      },
      location: null,
      unresolved: [],
    }),
  },
  {
    query: 'barato',
    data: withCadMeta({
      intent: NL_SEARCH_INTENTS.unknown,
      filters: {},
      location: null,
      unresolved: ['barato'],
    }),
  },
];

